module.exports = __webpack_public_path__ + "static/img/capacitacion.93d47f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/capacitacion.png
// module id = WhKV
// module chunks = 0